// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.payList .ant-table-body table{\n\n  border-collapse: collapse !important;\n\n}\n.stripeInvoiceTable > td {\n  border: 2px solid rgb(16, 24, 64) !important;\n  border-left: 0px !important;\n  border-right: 0px !important;\n\n  \n}\n.stripeInvoiceTable{\n  font-weight: 600;\n  font-size: 16px;\n\n}\n\n\n\n\n", ""]);
// Exports
module.exports = exports;
